export default class ApplicationVersion {
	build: string | null;

	constructor(build: string | null) {
		this.build = build;
	}
}
